import ImageComponent from "../../utils/ImageComponent";

/**
 * Accent per card, taken from the brand mesh — see FeatureArea.css for the
 * values behind each name.
 */
export type FeatureAccent =
  | "green"
  | "cyan"
  | "blue"
  | "teal"
  | "violet"
  | "rose";

type FeatureAreaCardProps = {
  image: string;
  heading: string;
  paragraph: string;
  accent?: FeatureAccent;
};

export default function FeatureAreaCard(props: FeatureAreaCardProps) {
  return (
    <div className={`fcard fcard--${props.accent ?? "green"}`}>
      <span className="fcard-glow" aria-hidden="true" />
      <div className="fcard-icon">
        <ImageComponent src={props.image} />
      </div>
      <h3 className="fcard-title">{props.heading}</h3>
      <p className="fcard-text">{props.paragraph}</p>
    </div>
  );
}
